import { makeUseAxios } from "axios-hooks";

import api from "../services/api";

export const useApi = makeUseAxios({ axios: api });
